import { useState } from "react";
import { INCONSISTENCY_KIND_META, severityMeta } from "../lib/labels.js";
import { SeverityBadge } from "./ui.js";

// Painel explicativo "Como funciona" da Central de inconsistências.
// Responde à pergunta do cliente: entender, na prática, o que a tela faz.
// Conteúdo dirigido pelo catálogo único (shared/labels.ts) — sem duplicação.
export function ComoFuncionaInconsistencias() {
  const [open, setOpen] = useState(true);
  const kinds = Object.entries(INCONSISTENCY_KIND_META);

  return (
    <div className="card mb-6 p-5" data-testid="como-funciona">
      <button className="flex w-full items-center justify-between" onClick={() => setOpen((v) => !v)}>
        <div className="flex items-center gap-2">
          <span className="text-lg">💡</span>
          <h2 className="font-semibold text-slate-800">Como funciona</h2>
        </div>
        <span className="text-slate-400">{open ? "▾" : "▸"}</span>
      </button>

      {open && (
        <div className="mt-4 space-y-4 text-sm text-slate-600">
          <p>
            A Central de inconsistências é uma <strong>rede de segurança de qualidade de dados</strong>. Ela inspeciona a
            planilha <em>BRASIL NOVO 2026</em> a cada importação e sinaliza tudo o que pode distorcer os números
            (erros de fórmula, chaves repetidas, formatos divergentes). Cada item aponta a <strong>aba</strong>, o
            <strong> local</strong> e um <strong>detalhe</strong> do problema para facilitar a correção na origem.
          </p>
          <p className="rounded-lg bg-amber-50 px-3 py-2 text-amber-800">
            ⏱ <strong>Cadência:</strong> a verificação roda <strong>na importação da planilha</strong> (em lote), não em
            tempo real. A lista reflete a última importação — reimporte para reavaliar.
          </p>

          {/* Legenda de severidade */}
          <div>
            <div className="mb-2 text-xs font-semibold uppercase tracking-wide text-slate-500">Severidade</div>
            <div className="flex flex-wrap gap-4">
              {["error", "warning", "info"].map((s) => (
                <div key={s} className="flex items-center gap-2">
                  <SeverityBadge value={s} />
                  <span className="text-xs text-slate-500">{severityMeta(s).description}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Glossário por tipo */}
          <div>
            <div className="mb-2 text-xs font-semibold uppercase tracking-wide text-slate-500">Tipos de inconsistência</div>
            <div className="grid gap-3 md:grid-cols-2">
              {kinds.map(([key, m]) => (
                <div key={key} className="rounded-lg border border-slate-100 p-3">
                  <div className="flex items-center gap-2">
                    <span className="font-medium text-slate-800">{m.label}</span>
                    <span className={`badge ${m.nature === "auto" ? "bg-blue-100 text-blue-700" : "bg-slate-100 text-slate-500"}`}>
                      {m.nature === "auto" ? "detecção automática" : "curado"}
                    </span>
                  </div>
                  <p className="mt-1 text-slate-600">{m.description}</p>
                  <p className="mt-1 text-xs text-slate-400"><strong>Como é detectado:</strong> {m.detection}</p>
                  <p className="mt-0.5 text-xs text-brand-700">→ {m.action}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
